export default __webpack_public_path__ + "static/media/png-icon.05684f92.webp";